import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import Inr from '@/components/Inr/index.vue';
import Thumb from '@/components/Thumb/index.vue';
let default_1 = class default_1 extends Vue {};
__decorate([Prop({
  default: {}
})], default_1.prototype, "data", void 0);
default_1 = __decorate([Component({
  name: 'LedgerInfoTab',
  components: {
    Inr,
    Thumb
  }
})], default_1);
export default default_1;